import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import _ from 'lodash'
import ls from 'local-storage'
import moment from 'moment'

import { NO_SHOW_LS_KEY, LOCALE_PREFIX } from './constants'

import hocConnect from './hocConnect'

import './style.scss'

@hocConnect
export default class LineBanner extends Component {
    static propTypes = {
        buttonsSetting: PropTypes.arrayOf(
            PropTypes.shape({
                text: PropTypes.string,
                onClick: PropTypes.func,
            })
        ),
        color: PropTypes.string,
        id: PropTypes.string.isRequired,
        noMoreShowButton: PropTypes.bool,
        show: PropTypes.bool.isRequired,
        style: PropTypes.object,
        text: PropTypes.string,
        textColor: PropTypes.string,
        toggleLineBanner: PropTypes.func.isRequired,
    }

    static defaultProps = {
        buttonsSetting: [],
        color: '#29abe2',
        noMoreShowButton: true,
        style: {},
        text: '',
        textColor: '#ffffff',
    }

    constructor(props) {
        super(props)

        this._showFromLS = _.get(this.decodeDataLS(ls(NO_SHOW_LS_KEY(props.id))), 'show', true)
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.text !== nextProps.text) return true
        if (this.props.color !== nextProps.color) return true
        if (this.props.textColor !== nextProps.textColor) return true
        if (this.props.show !== nextProps.show) return true
        if (this.props.noMoreShowButton !== nextProps.noMoreShowButton) return true
        if (this.props.id !== nextProps.id) return true
        if (!_.isEqual(this.props.buttonsSetting, nextProps.buttonsSetting)) return true
        if (!_.isEqual(this.props.style, nextProps.style)) return true

        return false
    }

    encodeDataLS = (show) => {
        try {
            return JSON.stringify({ show, timestamp: moment().unix() })
        } catch (_e) {
            return null
        }
    }

    decodeDataLS = (data) => {
        try {
            return JSON.parse(data)
        } catch (_e) {
            return null
        }
    }

    noMoreButtonOnClickHandler = () => {
        const { id, toggleLineBanner } = this.props

        toggleLineBanner(id)
        ls(NO_SHOW_LS_KEY(id), this.encodeDataLS(!this._showFromLS))
    }

    renderButton = (index, text, onClickFn) => (
        <div key={`banner_button_${index}`} className={'button'} onClick={onClickFn}>
            {text}
        </div>
    )

    render() {
        const { buttonsSetting, color, text, textColor, noMoreShowButton, show, style } = this.props

        if (!show || !this._showFromLS) return null

        const buttons = _.map(buttonsSetting, (button, index) => this.renderButton(index, button.text, button.onClick))
        const noMoreShowButtonEl = noMoreShowButton
            ? this.renderButton(
                  'noMore',
                  <FormattedMessage id={`${LOCALE_PREFIX}.noMoreShowButton`} />,
                  this.noMoreButtonOnClickHandler
              )
            : null

        return (
            <div className={'line-banner'} style={{ backgroundColor: color, color: textColor, ...style }}>
                <div className={'text'}>
                    <span>{text}</span>
                </div>
                <div className={'buttons'}>
                    {noMoreShowButtonEl}
                    {buttons}
                </div>
            </div>
        )
    }
}
